import React from "react";
import logo from "./Figures/Vectors/logo.svg";

const links = [
  { id: "aboutdoctor",   icon: "fa-user-doctor", label: "Η παιδίατρος" },
  { id: "aboutservices", icon: "fa-stethoscope",  label: "Παροχές" },
  { id: "aboutoffice",   icon: "fa-stethoscope",  label: "Το ιατρείο" },
  { id: "contact",       icon: "fa-phone",        label: "Επικοινωνήστε" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  const [active, setActive] = React.useState("");

  const handleClick = (id) => {
    setActive(id);
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="bg-white drop-shadow-sm relative z-50">
      <div className="container mx-auto px-4 flex items-center justify-between h-16">

        {/* Brand */}
        <div className="flex items-center gap-3 flex-shrink-0">
          <img src={logo} alt="" className="w-11 h-11" />
          <div>
            <h1 className="text-base font-semibold text-gray-900 leading-tight whitespace-nowrap">
              Βασιλική Μαργαριτοπούλου
            </h1>
            <p className="text-xs text-gray-400 italic leading-tight">
              "Τα πάντα... για τα παιδιά"
            </p>
          </div>
        </div>

        {/* Desktop links */}
        <ul className="hidden lg:flex items-center gap-1">
          {links.map(({ id, icon, label }) => (
            <li key={id}>
              <a
                href={`#${id}`}
                onClick={() => handleClick(id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors duration-150 ${
                  active === id
                    ? "text-sky-700 font-semibold bg-sky-50"
                    : "text-gray-600 font-medium hover:text-sky-700 hover:bg-sky-50"
                }`}
              >
                <i className={`fa-solid ${icon} text-sm opacity-75`}></i>
                {label}
              </a>
            </li>
          ))}
        </ul>

        {/* Hamburger */}
        <button
          className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Μενού πλοήγησης"
        >
          <i className={`fas ${open ? "fa-xmark" : "fa-bars"} text-lg`}></i>
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg">
          <ul className="flex flex-col px-4 py-3 gap-1">
            {links.map(({ id, icon, label }) => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  onClick={() => handleClick(id)}
                  className={`flex items-center gap-3 px-3 py-3 rounded-lg text-sm transition-colors duration-150 ${
                    active === id
                      ? "text-sky-700 font-semibold bg-sky-50"
                      : "text-gray-600 font-medium hover:text-sky-700 hover:bg-sky-50"
                  }`}
                >
                  <i className={`fa-solid ${icon} text-base opacity-75`}></i>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}
